import { useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import { useRouteServerErrorRegistration } from '@/config/routeServerError';
import { DASHBOARD, INVITE } from '@/constants/routes';
import Error from '@/pages/Error';
import { getAccessToken } from '@/utils/localStorage';

const PublicRoute = () => {
  const [error, setError] = useState(false);
  const location = useLocation();
  const token = getAccessToken();

  useRouteServerErrorRegistration(setError);

  if (error) {
    return <Error />;
  }
  if (token && !location.pathname.startsWith(INVITE)) {
    return <Navigate to={DASHBOARD} replace />;
  }
  return <Outlet />;
};

export default PublicRoute;
